import InitialSeedProductTemplatesPage from './InitialSeedProductTemplatesPage';
import RFQConfigureAttributePage from './RFQConfigureAttributePage';
import RFQGeneratePdfPage from './RFQGeneratePdfPage';
import RFQPlanAttributesPage from './RFQPlanAttributesPage';
import RFQPolicyAttributesPage from './RFQPolicyAttributesPage';
import RFQProductTemplateChecklistPage from './RFQProductTemplateChecklistPage';
import RFQProductTemplatesPage from './RFQProductTemplatesPage';
import ShelfRFQProductTemplatesPage from './ShelfRFQProductTemplatesPage';
import RFQSaveProductTemplatePage from './RFQSaveProductTemplatePage';
import RFQBenefitSummaryPage from './RFQBenefitSummaryPage';

export {
  InitialSeedProductTemplatesPage,
  RFQConfigureAttributePage,
  RFQGeneratePdfPage,
  RFQPlanAttributesPage,
  RFQPolicyAttributesPage,
  RFQProductTemplateChecklistPage,
  RFQProductTemplatesPage,
  ShelfRFQProductTemplatesPage,
  RFQSaveProductTemplatePage,
  RFQBenefitSummaryPage,
};
